import React, { useState, useEffect } from 'react'
import { db } from '../firebase';
import firebase from 'firebase'
import Swal from 'sweetalert2';
import { Form } from 'react-bootstrap'
import Paper from '@material-ui/core/Paper';
import { Fade } from '@material-ui/core';



const EventForm = (props) => {

    const intialStateValues = {
        name: '',
        description: '',
        dateEvent: '',
    }


    const [image, setImage] = useState('')
    const [urlImage, setUrlImage] = useState('')


    const [values, setValues] = useState(intialStateValues);

    const handleInputChange = e => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    }



    const handleImageChange = e => {
        setImage(e.target.files[0])
    }




    const handlerSubmit = (e) => {
        e.preventDefault();
        handleUpload(image)
        setValues({ ...intialStateValues })
    }


    const handleUpload = async (image) => {

        var storageRef = firebase.storage().ref()
        var uploadTask = storageRef.child('works/' + image.name).put(image)
        //listen for state changes

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes * 100)
                console.log(`Upload is ${progress} done`)

                switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED:
                        console.log('Upload is paused')
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running');
                        break;

                    default: console.log(snapshot.state)
                }
            }, function (error) {

                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                    case 'storage/canceled':
                        console.log('User canceled the upload')
                        break;


                    case 'storage/unknown':
                        console.log('Unknown error occurred, inspect error.serverResponse')
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    default: break
                }
            },

            function () {
                // Upload completed successfully, now we can get the download URL
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    setUrlImage(downloadURL)

                    var objAux = values
                    objAux['url'] = downloadURL
                    
                    db.collection('works').doc().set(objAux)
                    console.log(`URL IMAGE ${downloadURL}`)
                    document.getElementById('inputImage').value =''
                    

                });
            })

    }
    const getLinkById = async (id) => {
        const doc = await db.collection('works').doc(id).get();
        setValues({ ...doc.data() })
    }

    useEffect(() => {
        if (props.currentId === '') {
            setValues({ ...intialStateValues });
        } else {
            getLinkById(props.currentId);
        }



    }, [props.currentId])

    return (

        <Fade in={true}>

            <Paper elevation={0}>

                <form className='card card-body' onSubmit={handlerSubmit}>
                    <div className='form-group input-group mb-2'>
                        <div className="mb-3">
                            <input type="file" id='inputImage' name="image" onChange={handleImageChange} />
                        </div>

                    </div>


                    <div className="form-group input-group mb-2">
                        <div className="input-group-text bg-light">
                            <i className='material-icons'>create</i>
                        </div>
                        <input placeholder='Work title' onChange={handleInputChange} value={values.name} type="text" className='form-control' name="name" id="" />
                    </div>

                    <div className="form-group mb-2">
                        <textarea onChange={handleInputChange} value={values.description} name="description"
                            cols="30" placeholder='Work description' rows="3"
                            className='form-control mb-2'></textarea>
                    </div>

                    <div className="form-group mb-2">
                        <span>When this work was made</span>
                        <input onChange={handleInputChange} value={values.dateEvent} className="form-control mb-2" type="date" name="dateEvent" />
                    </div>

                    <button className='btn btn-primary btn-block'>
                        {props.currentId === '' ? 'Publish' : 'Update data'}
                    </button>
                </form>
            </Paper>
        </Fade>
    )
}

export default EventForm;